import Text from '@cartwhl/ui/base/TextNew';
import BookmarkIcon from '@cartwhl/ui/icons/BookmarkIcon';
import LinkIcon from '@cartwhl/ui/icons/LinkIcon';
import TrashIcon from '@cartwhl/ui/icons/TrashIcon';

import AssetLibraryBlockedActionTooltip from './AssetLibraryTrashActionTooltip';

const PREVIEW_BOOKMARK_BUTTON_CLASS =
  'border-primary bg-primary hover:bg-secondary flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border shadow-sm transition-colors';

const PREVIEW_MOVE_TO_TRASH_BUTTON_CLASS =
  'border-primary text-red hover:bg-secondary flex h-10 shrink-0 cursor-pointer items-center gap-2 rounded-lg border px-4 transition-colors';

export function AssetLibraryPreviewShareLinkButton({
  onClick,
}: {
  onClick?: () => void;
}) {
  return (
    <button
      type="button"
      aria-label="Copy share link"
      className={PREVIEW_BOOKMARK_BUTTON_CLASS}
      onClick={onClick}
    >
      <LinkIcon className="text-primary h-5 w-5" />
    </button>
  );
}

export function AssetLibraryPreviewBookmarkButton({
  isBookmarked,
  onClick,
}: {
  isBookmarked: boolean;
  onClick?: () => void;
}) {
  return (
    <button
      type="button"
      aria-label={isBookmarked ? 'Remove bookmark' : 'Add bookmark'}
      aria-pressed={isBookmarked}
      className={PREVIEW_BOOKMARK_BUTTON_CLASS}
      onClick={onClick}
    >
      <BookmarkIcon className="text-primary h-5 w-5" fill={isBookmarked} />
    </button>
  );
}

export function AssetLibraryPreviewMoveToTrashButton({
  onClick,
  disabled = false,
}: {
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <AssetLibraryBlockedActionTooltip disabled={disabled} inModal side="right">
      <button
        type="button"
        disabled={disabled}
        className={`${PREVIEW_MOVE_TO_TRASH_BUTTON_CLASS} ${
          disabled ? 'cursor-not-allowed opacity-50' : ''
        }`}
        onClick={disabled ? undefined : onClick}
      >
        <Text token="14/medium">Move to trash</Text>
        <TrashIcon className="size-5" />
      </button>
    </AssetLibraryBlockedActionTooltip>
  );
}
